import React from 'react';
import { ImageProps } from '@components/image';
import generateId from '@helpers/generate-id';
import Wrapper from '@components/wrapper.styled';
import { RichTextBlock } from 'prismic-reactjs';
import { defaultTheme } from '@styles/theme.styled';
import Text from '@components/text';
import {
  Enclosure,
  SecurityGrid,
  SecurtiyImage,
  Container,
  StyledText,
  Ticker,
  StyledSection,
} from './security-labels.styled';

const SecurityLabelIdGenerator = generateId();

export interface SecurityLabelItemProps {
  image?: ImageProps;
}

interface SecurityLabelProps {
  items: SecurityLabelItemProps[];
  title?: string;
  description?: RichTextBlock[];
  ticker?: boolean;
  backgroundColor?: keyof typeof defaultTheme.backgroundColors;
  enclosureColor?: keyof typeof defaultTheme.backgroundColors;
  itemsPerRow?: number;
}

const SecurityLabels = ({
  items,
  title,
  description,
  backgroundColor = 'dark',
  enclosureColor,
  itemsPerRow = 3,
  ticker,
}: SecurityLabelProps): JSX.Element => {
  const isTextReceived = !!(title !== '' || description?.length);
  if (items?.length === 0 && isTextReceived) {
    return <></>;
  }

  return (
    <StyledSection backgroundColor={enclosureColor || 'white'}>
      <Wrapper>
        <Enclosure backgroundColor={backgroundColor}>
          {isTextReceived && (
            <Container backgroundColor={backgroundColor}>
              {!!title && (
                <StyledText
                  tag="h2"
                  type="title"
                  fontSize="heading3"
                  stringText={title}
                  margin="none"
                  fontColor="white"
                />
              )}
              {!!description?.length && (
                <Text
                  type="subheading"
                  richText={description}
                  fontColor={
                    backgroundColor === 'dark' || backgroundColor === 'primary' ? 'white' : 'dark'
                  }
                />
              )}
            </Container>
          )}
          {ticker ? (
            <Ticker itemCount={items.length}>
              {items.map(({ image }): JSX.Element => {
                return (
                  <SecurtiyImage
                    key={SecurityLabelIdGenerator.next().value}
                    url={image?.url}
                    alt={image?.alt}
                    gatsbyImageData={image?.gatsbyImageData}
                    height={image?.gatsbyImageData?.height}
                    width={image?.gatsbyImageData?.width}
                    objectFit="contain"
                  />
                );
              })}
              {items.map(({ image }): JSX.Element => {
                return (
                  <SecurtiyImage
                    key={SecurityLabelIdGenerator.next().value}
                    url={image?.url}
                    alt={image?.alt}
                    gatsbyImageData={image?.gatsbyImageData}
                    height={image?.gatsbyImageData?.height}
                    width={image?.gatsbyImageData?.width}
                    objectFit="contain"
                  />
                );
              })}
            </Ticker>
          ) : (
            <SecurityGrid itemsPerRow={itemsPerRow}>
              {items.map(({ image }): JSX.Element => {
                return (
                  <SecurtiyImage
                    key={SecurityLabelIdGenerator.next().value}
                    url={image?.url}
                    alt={image?.alt}
                    gatsbyImageData={image?.gatsbyImageData}
                    objectFit="contain"
                  />
                );
              })}
            </SecurityGrid>
          )}
        </Enclosure>
      </Wrapper>
    </StyledSection>
  );
};

export default SecurityLabels;
